export interface IBaseCanvasProps {
  readonly height: number
  readonly width: number
  readonly z?: number
  readonly top?: string | number
  readonly left?: string | number
  readonly hasAlpha?: boolean
  readonly canDebug?: boolean
  readonly className?: string
}

export interface ICanvas {
  readonly canvas: HTMLCanvasElement
  readonly ctx: CanvasRenderingContext2D
}

export interface ICanvasProps extends IBaseCanvasProps {
  readonly render: (ctx: CanvasRenderingContext2D) => void
  readonly update?: (deltaTime: number) => void
  readonly fps?: number
  readonly isStatic?: boolean
}

export enum ECanvasEvent {
  Pause  = 'Canvas:Pause',
  Resume = 'Canvas:Resume'
}
